import { connectRouter, ConnectedRouter, push, replace } from 'connected-react-router';
import treeScanner from './treeScanner';

class DataRouter {
    constructor ({ routes = [], datasources = {} }, dataEngine, store) {
        this.routes = routes;
        this.datasources = datasources;
        this.dataEngine = dataEngine;
        this.store = store;
        this.dispatch = store.dispatch;
        this.currentRoute = null;
        this.updateHeartbeatAction = this.dataEngine && this.dataEngine.engineActions &&
            this.dataEngine.engineActions.DATA_UPDATE_HEARTBEAT;

        // Probably makes more sense to move this to middleware
        // Or adapt the connected-react-router middleware to suite
        // this purpose
        if (store) {
            const unsubFirstRoute = store.subscribe(() => {
                const state = store.getState();
                this.currentRoute = state.router.location;
                unsubFirstRoute();
            });
            store.subscribe(() => {
                const state = store.getState();
                const changedRoute = this.currentRoute && this.currentRoute.location !== state.router.location;
                const heartbeatUpdated = state.latestAction === this.updateHeartbeatAction;
                if (changedRoute || heartbeatUpdated) {
                    const route = this.currentRoute = state.router;
                    this.requestRouteData(route.location);
                }
            });
        }
    }

    requestRouteData (route = '/') {
        const state = this.store.getState() || {};
        const {pathname = route} = route;
        const promises = treeScanner(pathname, this.routes, this.dataEngine, state);
        return promises;
    }

}

export default DataRouter;
export { DataRouter, connectRouter, ConnectedRouter, push as pushRouteAction, replace as replaceRouteAction };
export { Router, Switch, Route, withRouter } from 'react-router';
